import { BusinessEventType } from "@reef-os/utils/enums/businessEventType"
import { EventStatus } from "@reef-os/utils/enums/eventStatus"
import moment from "moment"
import momentUtils from "@/moment-utils"

let eventDetailsMixin = {
	computed: {
		eventName() {
			return this.event ? this.event.name : ""
		},
		eventDescription() {
			return this.event ? this.event.description : ""
		},
		eventRestaurantName() {
			return this.event && this.event.restaurantName
				? this.event.restaurantName
				: ""
		},
		eventMonth() {
			if (this.event) {
				switch (this.event.type) {
					case BusinessEventType.POPUP:
						if (this.event.start_date) {
							return moment(this.event.start_date, "YYYY-MM-DD").format("MMM")
						}
						break
					case BusinessEventType.VIRTUAL:
						if (this.event.end_date) {
							return moment(this.event.end_date, "YYYY-MM-DD").format("MMM")
						}
						break
				}
			}
			return ""
		},
		eventDate() {
			if (this.event) {
				switch (this.event.type) {
					case BusinessEventType.POPUP:
						if (this.event.start_date) {
							return moment(this.event.start_date, "YYYY-MM-DD").format("MMMM Do")
						}
						break
					case BusinessEventType.VIRTUAL:
						if (this.event.end_date) {
							return moment(this.event.end_date, "YYYY-MM-DD").format("MMMM Do")
						}
						break
				}
			}
			return ""
		},
		eventDay() {
			if (this.event) {
				switch (this.event.type) {
					case BusinessEventType.POPUP:
						if (this.event.start_date) {
							return moment(this.event.start_date, "YYYY-MM-DD").format("DD")
						}
						break
					case BusinessEventType.VIRTUAL:
						if (this.event.end_date) {
							return moment(this.event.end_date, "YYYY-MM-DD").format("DD")
						}
						break
				}
			}
			return ""
		},
		eventTime() {
			if (this.event) {
				switch (this.event.type) {
					case BusinessEventType.POPUP:
						if (this.event.start_time) {
							return moment(this.event.start_time, "HH:mm:ss").format("h:mm A")
						}
						break
					case BusinessEventType.VIRTUAL:
						if (this.event.end_time) {
							return moment(this.event.end_time, "HH:mm:ss").format("h:mm A")
						}
						break
				}
			}
			return ""
		},
		lastCall() {
			let lastCall = ""
			let lastCallDate = null
			if (this.event && this.event.pre_order_end_date && this.event.pre_order_end_time) {
				lastCallDate = `${this.event.pre_order_end_date} ${this.event.pre_order_end_time}`
			}
			if (lastCallDate) {
				const now = moment()
				lastCall = momentUtils.timeDiff(
					moment(lastCallDate, "YYYY-MM-DD HH:mm:ss"),
					now
				)
			}
			return lastCall
		},
		eventBannerStyle() {
			const image = this.event ? this.event.image : ""
			return {
				backgroundImage: `url(${image})`,
				backgroundSize: "cover",
				backgroundRepeat: "no-repeat",
				backgroundPosition: "center"
			}
		},
		isInPreorderStatus() {
			if (this.event) {
				return this.event.status == EventStatus.PREORDER
			}
			return false
		}
	}
}

export default eventDetailsMixin